import axios from "axios";
import { format, parseISO, startOfMonth } from "date-fns";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });
const TOKEN = "dbr_token";

export const setToken = (t) => (t ? localStorage.setItem(TOKEN, t) : localStorage.removeItem(TOKEN));

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !err.config?.url?.includes("/auth/login")) {
      setToken(null);
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

const nf = new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", minimumFractionDigits: 2 });
export const inr = (v) => (v === null || v === undefined || v === "" ? "" : nf.format(v));
export const fmtDate = (s) => {
  if (!s) return "";
  try { return format(parseISO(s), "dd MMM yyyy"); } catch { return s; }
};
export const fmtDateTime = (s) => {
  if (!s) return "";
  try { return format(parseISO(s), "dd MMM yyyy, HH:mm"); } catch { return s; }
};
export const todayISO = () => format(new Date(), "yyyy-MM-dd");
export const monthStartISO = () => format(startOfMonth(new Date()), "yyyy-MM-dd");

export async function download(path, params, filename) {
  const r = await api.get(path, { params, responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

const PERMS = {
  admin: ["*"],
  accountant: ["entry:vi", "entry:dse", "entry:fl", "entry:cash", "master:write", "report:all", "report:limited", "reversal:request", "import:preview", "dashboard"],
  staff: ["entry:dse", "entry:fl", "report:limited", "reversal:request", "dashboard"],
  viewer: ["report:all", "report:limited", "dashboard"],
};
export const can = (user, perm) => {
  const p = PERMS[user?.role] || [];
  return p.includes("*") || p.includes(perm);
};
export const ROLE_LABEL = { admin: "Admin", accountant: "Accountant", staff: "Staff", viewer: "View Only" };
